import { addLineBreaksToTitle, getLongestString, getMostLongLineInTitle, isNeedAddLineBreak } from "../lineBreaks";
import { ColumnRangeHeader } from "../models";

export function getLongestTitleFromHeader(header: ColumnRangeHeader) {
  const formattedTitle = isNeedAddLineBreak(header.title) ? addLineBreaksToTitle(header.title) : header.title;
  const mainTitle = getMostLongLineInTitle(formattedTitle);
  return getLongestString([...header.subTitles.map(x => x.slice(0, 20)), mainTitle]);
}
